import { createGlobalStyle } from "styled-components";
import "../scss/main.scss";

const globalStyle = createGlobalStyle`
  
`;

export default globalStyle;
